import type { InjectedRouter } from 'react-router';

import { MULTI_ORG } from '../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../helpers/features/featureFlags';
import AuthRegister from '../auth/pages/Register';
import type { RouterProps } from '../../types';

import RegisterV2 from './pages/Register';

type Props = {
  location: RouterProps['location'];
  router: InjectedRouter;
};

/**
 * Page-level switch for `/auth/register`, gated on the `MULTI_ORG` feature flag: it renders the multi-org `RegisterV2`
 * when the flag is enabled and the existing `AuthRegister` page otherwise. `RegisterV2` uses `router` for client-side
 * navigation to login; the V1 page needs only `location`.
 */
const RegisterRouteSwitch = ({ location, router }: Props) =>
  (useIsFeatureEnabled(MULTI_ORG)
    ? <RegisterV2 location={location} router={router} />
    : <AuthRegister location={location} />);

export default RegisterRouteSwitch;
